<template>
    <div class="l-ss-c-price-wrapper">
        <div
            class="l-ss-c-price-current-wrapper"
            v-if="!multyPrices.length">
            <span
                :class="[{ 'l-ss-c-offer-info-prices-vs-old': hasOldPrice || priceWithPromoCode }]"
                class="l-ss-c-offer-info-prices">
                <price-wrapper
                    :currency="offer.currency"
                    :value="priceWithPromoCode"
                    class="l-ss-c-offer-info-price"
                    title="Цена по промокоду"
                    :class="{ 'l-ss-c-offer-info-price-discount': !!hasOldPrice||!!priceWithPromoCode, 'l-ss-c-offer-info-price-priceWithPromoCode': !!priceWithPromoCode }"/>
                <price-wrapper
                    :currency="offer.currency"
                    :value="offer.price"
                    class="l-ss-c-offer-info-price"
                    :class="{ 'l-ss-c-offer-info-price-discount': !!hasOldPrice, 'l-ss-c-offer-info-priceWithoutPromoCode': !!priceWithPromoCode }"/>
                <price-wrapper
                    v-if="offer.price !== hasOldPrice"
                    :currency="offer.currency"
                    :is-old="true"
                    :value="hasOldPrice"
                    class="l-ss-c-offer-info-price l-ss-c-offer-info-price-old"/>
            </span>
            <slot name="cart"></slot>
        </div>

        <div
            class="l-ss-c-price-multy-wrapper"
            v-if="multyPrices.length">
            <div
                v-for="price in multyPrices"
                :key="price.type"
                class="l-ss-c-price-multy-item">
                <div>
                    {{ price.label }}:
                </div>
                <span
                    :class="[{ 'l-ss-c-offer-info-prices-vs-old': offer.oldPrice }]"
                    class="l-ss-c-offer-info-prices">
                    <price-wrapper
                        :currency="offer.currency"
                        :is-old="true"
                        :value="price.oldPrice"
                        class="l-ss-c-offer-info-price l-ss-c-offer-info-price-old"/>
                    <price-wrapper
                        :currency="offer.currency"
                        :value="price.price"
                        class="l-ss-c-offer-info-price"
                        :class="{ 'l-ss-c-offer-info-price-discount': !!offer.oldPrice }"/>
                </span>
            </div>
            <slot name="cart"></slot>
        </div>
    </div>
</template>

<script>
    import PriceWrapper from './price-wrapper';

    export default {
        components: {
            PriceWrapper,
        },
        props: ['offer', 'showCartButton', 'isCompletion'],
        computed: {
            cartButtonClasses() {
                if (this.showCartButton) {
                    return ['justify-between', 'flex-wrap', 'w-full', 'items-center'];
                }
                return [];
            },
            multyPricesMap() {
                return (this.$configuration.offer?.prices?.length) ? this.$configuration.offer.prices : [];
            },

            multyPrices() {
                let result = [];

                if (this.offer.prices) {
                    Object.keys(this.offer.prices).forEach( (one , ind) => {
                        const pricesMap = this.multyPricesMap.filter( el => one === el.type );
                        result[ind] = {
                            type: one,
                            label: (pricesMap.length) ? pricesMap[0].label : null,
                            oldPrice: this.offer.prices[one].oldPrice,
                            price: this.offer.prices[one].price,
                        };
                    });
                }
                result = result.filter(one => one.label);
                return result;
            },

            hasOldPrice() {
                return this.offer.oldPrice ?? this.offer.old_price;
            },
            priceWithPromoCode() {
                if (this.offer.params && 'priceWithPromoCode' in this.offer.params && this.offer.price !== this.offer.params['priceWithPromoCode']) {
                    return this.offer.params['priceWithPromoCode'];
                }
                return '';
            },
        },
    };
</script>